import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Circle, Line } from 'react-shapes';
import { statusToString } from "./listastatus";

interface Props {
    texto: string
}

class EstadoHistoricoNoRX extends React.PureComponent<Props> {

    render() {
        const { texto } = this.props;
        return (
            <div style={{ fontSize: 12, display: 'inline-block' }}>
                {this.props.texto}
            </div>
        );
    }
}
export const EstadoHistorico = componentToRx(EstadoHistoricoNoRX);

interface PropsItem {
    texto: string;
    fecha: string;
    abajo: boolean;
    arriba: boolean;
    cancelado?: boolean;
}

class ContenedorEstadosHistoricos extends React.PureComponent<PropsItem> {
    render() {
        const texto = this.props.texto;
        const fecha = this.props.fecha;
        const abajo = this.props.abajo;
        const arriba = this.props.arriba;
        const color = this.props.cancelado ? 'red' : '#3399FF';
        const colorCirculo = this.props.cancelado ? 'red' : '#3333FF';
        const bordeLinea = this.props.cancelado ? 'black' : '#3333FF';

        return [
            <li style={{ margin: 'auto', width: '100%' }}>

                <div style={{ display: 'flex', flexDirection: 'row' }} >

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '20%' }} >
                        {
                            arriba &&
                            <div style={{ flex: '1 1 auto', width: '5px' }} />
                        }

                        <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
                            <EstadoHistorico texto={fecha} />
                        </div>

                        {
                            abajo &&
                            <div style={{ flex: '1 1 auto', width: '5px' }} />
                        }

                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', flexGrow: 2, width: '10%' }} >

                        {
                            arriba &&
                            <div style={{ flex: '1 1 auto', width: '5px', background: color }} />
                        }

                        <div style={{ flex: '0 0 auto' }}>
                            <div style={{ width: '15px', height: '15px', background: colorCirculo, borderRadius: '7.5px' }}>
                            </div>
                        </div>

                        {
                            abajo &&
                            <div style={{ flex: '1 1 auto', width: '5px', background: color }} />
                        }
                    </div>


                    <div style={{ flexGrow: 99, width: '70%' }}>

                        {
                            arriba ?
                                <div style={{ height: 30 }}>
                                </div>
                                :
                                <div style={{}}>
                                </div>
                        }

                        <div style={{ textAlign: 'left' }}>
                            <EstadoHistorico texto={texto} />
                        </div>

                        {
                            abajo ?
                                <div style={{ height: 30, verticalAlign: 'center' }}>
                                </div>
                                :
                                <div style={{}}>
                                </div>
                        }

                    </div>
                </div>

            </li>
        ];
    }
}

interface Entidad {
    texto: string;
    fecha: string;
    abajo: boolean;
    arriba: boolean;
    cancelado?: boolean;
}

class BarraEstadosHistoricosNoRx extends React.PureComponent<{ value: Entidad[] }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <ul style={{ display: 'flex', flexDirection: 'column', padding: 0, margin: 0, listStyle: 'none' }}>
                    {
                        [
                            ...x.map((x, i) => <ContenedorEstadosHistoricos key={i} texto={x.texto} fecha={x.fecha} abajo={x.abajo} arriba={x.arriba} cancelado={x.cancelado} />)
                        ]
                    }
                </ul>
            </div>
        )
    }
}

export const BarraEstadosHistoricos = componentToRx(BarraEstadosHistoricosNoRx);


const now = new Date();

export function statusToEstadoHistorico(status: models.StatusRastreoDTO[]): Entidad[] {

    var res = status
        .map((x, i) => {
            var punto = {
                texto: statusToString(x.Status) + ": " + x.NombreSucursal,
                fecha: kea.formatDate(x.Fecha),
                abajo: i != status.length - 1,
                arriba: i != 0,
            } as Entidad;

            return punto;
        });

    return res;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/estadoshistoricos.tsx